import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class OneSignalNotificationEventService {
  private notificationClickSubject = new Subject<string>();
  public notificationClick$ = this.notificationClickSubject.asObservable();

  public emitNotificationClick(launchUrl: string) {
    this.notificationClickSubject.next(launchUrl);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/one-signal-notification-event.service.ts